import { render } from "./AlzataDialog.vue?vue&type=template&id=9ebbf526"
import script from "./AlzataDialog.vue?vue&type=script&lang=js"
export * from "./AlzataDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__